"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "token-wrapper align-center" };
const _hoisted_3 = ["type"];
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const Modal_vue_1 = __importDefault(require("../Modal.vue"));
const smartHRImportRequest_1 = require("../../requests/smartHRImportRequest");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SmartHRAttendanceTokenModal',
    props: {
        userId: {
            type: Number,
            required: true,
        },
        branchId: {
            type: Number,
            required: true,
        },
    },
    emits: ["open-alert-modal"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const { t } = (0, vue_i18n_1.useI18n)();
        const token = (0, vue_3.ref)("");
        const isLoading = (0, vue_3.ref)(false);
        const isVisible = (0, vue_3.ref)(false);
        const isTokenVisible = (0, vue_3.ref)(false);
        const emits = __emit;
        function openModal() {
            isVisible.value = true;
        }
        __expose({
            openModal,
        });
        function closeModal() {
            isVisible.value = false;
            isTokenVisible.value = false;
            token.value = "";
        }
        async function setToken() {
            try {
                isLoading.value = true;
                const res = await (0, smartHRImportRequest_1.smartHRAttendanceTokenPatchRequest)(props.userId, props.branchId, token.value);
                if (!res.ok) {
                    const body = await res.json();
                    const msg = body?.alert || body?.error || t('general.error_retry');
                    emits("open-alert-modal", msg);
                    return;
                }
                window.location.reload();
            }
            catch (err) {
                emits('open-alert-modal', t('general.error_retry'));
            }
            finally {
                isLoading.value = false;
            }
        }
        function toggleTokenVisibility() {
            isTokenVisible.value = !isTokenVisible.value;
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? "loading" : "";
        });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    "has-title-divider": true,
                    "has-footer-divider": false
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.smarthr_api_token')), 1 /* TEXT */)
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("label", null, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.new_api_token')) + " ", 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((token).value = $event)),
                                        class: "form-input br-5",
                                        type: isTokenVisible.value ? 'text' : 'password'
                                    }, null, 8 /* PROPS */, _hoisted_3), [
                                        [vue_2.vModelDynamic, token.value]
                                    ]),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "token-visibility-btn align-center",
                                        onClick: toggleTokenVisibility
                                    }, [
                                        (0, vue_2.createElementVNode)("i", {
                                            class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", isTokenVisible.value ? 'zmdi-eye-off' : 'zmdi-eye'])
                                        }, null, 2 /* CLASS */)
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                            onClick: setToken
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('general.save')), 3 /* TEXT, CLASS */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
